<template>
  <div class="button-container simce-matrix-uploader">
    <ButtonPrime
      :label="testButtonLabel"
      :icon="testButtonIcon"
      :class="testButtonClass"
      :loading="isLoadingTest"
      @click="cargarMatricesSimcePregunta"
      :disabled="isDisabledTest"
    />
    <ButtonPrime
      :label="practicaButtonLabel"
      :icon="practicaButtonIcon"
      :class="practicaButtonClass"
      :loading="isLoadingPractica"
      @click="cargarMatricesSimcePractica"
      :disabled="isDisabledPractica"
    />
    <ToggleVigenciaButton
      :id-capitulo="idCapitulo"
      :usuario-id="usuarioId"
      @vigencia-toggled="onVigenciaToggled"
      @vigencia-error="onVigenciaError"
    />
  </div>
</template>

<script>
import MatrizService from '@/services/MatrizService';
import ButtonPrime from 'primevue/button';
import ToggleVigenciaButton from './ToggleVigenciaButton.vue';

export default {
  name: 'MatrixUploaderSimce',
  components: {
    ButtonPrime,
    ToggleVigenciaButton
  },
  props: {
    idCurso: { type: Number, required: true },
    idAsignatura: { type: Number, required: true },
    idUnidad: { type: Number, default: 0 },
    idCapitulo: { type: Number, default: 0 },
    idVideo: { type: Number, default: 0 },
    usuarioId: { type: Number, required: true }
  },
  data() {
    return {
      isLoadingTest: false,
      testProcessStatus: null,
      isLoadingPractica: false,
      practicaProcessStatus: null
    };
  },
  computed: {
    testButtonLabel() {
      if (this.isLoadingTest) return 'Cargando matrices SIMCE…';
      if (this.testProcessStatus === 'success') return 'Matrices test SIMCE listas';
      if (this.testProcessStatus === 'error') return 'Error al cargar';
      return 'Matrices test SIMCE (30 × 2)';
    },
    testButtonIcon() {
      if (this.isLoadingTest) return 'pi pi-spin pi-spinner';
      if (this.testProcessStatus === 'success') return 'pi pi-check';
      if (this.testProcessStatus === 'error') return 'pi pi-times';
      return 'pi pi-table';
    },
    testButtonClass() {
      if (this.isLoadingTest) return 'p-button-info';
      if (this.testProcessStatus === 'success') return 'p-button-success';
      if (this.testProcessStatus === 'error') return 'p-button-danger';
      return 'p-button-info';
    },
    isDisabledTest() {
      return this.isLoadingTest;
    },
    practicaButtonLabel() {
      if (this.isLoadingPractica) return 'Cargando matrices SIMCE…';
      if (this.practicaProcessStatus === 'success') return 'Matrices práctica SIMCE listas';
      if (this.practicaProcessStatus === 'error') return 'Error al cargar';
      return 'Matrices práctica SIMCE (30 × 6)';
    },
    practicaButtonIcon() {
      if (this.isLoadingPractica) return 'pi pi-spin pi-spinner';
      if (this.practicaProcessStatus === 'success') return 'pi pi-check';
      if (this.practicaProcessStatus === 'error') return 'pi pi-times';
      return 'pi pi-table';
    },
    practicaButtonClass() {
      if (this.isLoadingPractica) return 'p-button-info';
      if (this.practicaProcessStatus === 'success') return 'p-button-success';
      if (this.practicaProcessStatus === 'error') return 'p-button-danger';
      return 'p-button-secondary';
    },
    isDisabledPractica() {
      return this.isLoadingPractica;
    }
  },
  methods: {
    async cargarMatricesSimcePregunta() {
      this.isLoadingTest = true;
      this.testProcessStatus = null;

      try {
        const payload = {
          IdCapitulo: this.idCapitulo,
          IdAsignatura: this.idAsignatura,
          IdCurso: this.idCurso,
          IdUnidad: this.idUnidad,
          UsuarioId: this.usuarioId
        };

        const response = await MatrizService.saveMatricesSimcePregunta(payload);

        if (response.Message && response.Message.includes('No hay suficientes preguntas')) {
          this.testProcessStatus = 'error';
          this.$emit('matrix-simce-pregunta-error', response.Message);
        } else if (
          response.Message &&
          (response.Message.includes('creadas') || response.Message.includes('actualizadas'))
        ) {
          this.testProcessStatus = 'success';
          this.$emit('matrix-simce-pregunta-loaded', response.Message);
        } else {
          this.testProcessStatus = 'error';
          this.$emit('matrix-simce-pregunta-error', 'Respuesta inesperada del servidor');
        }
      } catch (error) {
        const errorMsg =
          error.response?.data?.Message || error.response?.data || 'Error al cargar matrices test SIMCE';
        this.testProcessStatus = 'error';
        this.$emit('matrix-simce-pregunta-error', errorMsg);
      } finally {
        this.isLoadingTest = false;
        setTimeout(() => {
          this.testProcessStatus = null;
        }, 3000);
      }
    },

    async cargarMatricesSimcePractica() {
      this.isLoadingPractica = true;
      this.practicaProcessStatus = null;

      try {
        const payload = {
          IdCapitulo: this.idCapitulo,
          IdAsignatura: this.idAsignatura,
          IdCurso: this.idCurso,
          IdUnidad: this.idUnidad,
          UsuarioId: this.usuarioId
        };

        const response = await MatrizService.saveMatricesSimcePractica(payload);

        if (response.Message && response.Message.includes('No hay suficientes preguntas')) {
          this.practicaProcessStatus = 'error';
          this.$emit('matrix-simce-practica-error', response.Message);
        } else if (
          response.Message &&
          (response.Message.includes('creadas') || response.Message.includes('actualizadas'))
        ) {
          this.practicaProcessStatus = 'success';
          this.$emit('matrix-simce-practica-loaded', response.Message);
        } else {
          this.practicaProcessStatus = 'error';
          this.$emit('matrix-simce-practica-error', 'Respuesta inesperada del servidor');
        }
      } catch (error) {
        const errorMsg =
          error.response?.data?.Message || error.response?.data || 'Error al cargar matrices práctica SIMCE';
        this.practicaProcessStatus = 'error';
        this.$emit('matrix-simce-practica-error', errorMsg);
      } finally {
        this.isLoadingPractica = false;
        setTimeout(() => {
          this.practicaProcessStatus = null;
        }, 3000);
      }
    },

    onVigenciaToggled(event) {
      this.$emit('chapter-vigencia-updated', event.message);
    },

    onVigenciaError(errorMsg) {
      this.$emit('chapter-vigencia-error', errorMsg);
    }
  }
};
</script>

<style scoped>
.button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.p-button {
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.p-button:hover {
  transform: translateY(-2px);
}
</style>
